import React from "react";
import { FormText } from "react-bootstrap";
import { connect } from "react-redux";
import { Link  , useParams} from "react-router-dom";
import { bindActionCreators } from "redux";
import { Field, reduxForm } from "redux-form";
import Logo from "../../assets/images/dummyImage.png";
import { resetPasswordNew } from "../../actions/auth";
import { toastr } from "react-redux-toastr";
import Particles from "./particle";
import brandsekLoginBanner from "../../assets/images/login.png";
import logo from "../../assets/images/logo.png";
import $ from "jquery";

var Model = require("./model");

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = { userMessage: "", email: "", showPassword: false };

    if (this.props.match.params.reset_code) {
      Model.default
        .encryptEmail(this.props.match.params.reset_code)
        .then((response) => {
          if (response.data.error) {
            toastr.error("Error", response.data.userMessage);
          } else {
            this.setState({
              email: response.data.data,
            });
          }
        });
    }
  }

  componentDidUpdate() {
    if (
      this.state.loading &&
      this.props.auth.user &&
      this.props.auth.user.passwordReset
    ) {
      this.setState({
        loading: false,
      });

      this.props.history.push("/");
    }
  }

  resetPassword = () => {
    let password = $("#passwords").val();
    let confirmPassword = $("#confirmPassword").val();
    if (password == "") {
      toastr.error("Error", "Please enter password");
      return false;
    }
    if (confirmPassword == "") {
      toastr.error("Error", "Please enter confirm password");
      return false;
    }
    if (password != confirmPassword) {
      toastr.error("Error", "Password mismatch");
      return false;
    }
   
    let props = { password, confirmPassword};
    //let props = { password, confirmPassword, propRedirect:this.props.history };
    this.setState({ loading: true });
    this.props.resetPasswordNew({
      ...props,
      resetCode: this.props.match.params.reset_code,
    });
  };

  render() {
    let brandsek = "../../assets/images/image-gallery/brandsek-logo.svg";
    let browser = window.location.href.split("/");
    if (browser[2].split(".")[0] && browser[2].split(".")[0] == "brandshield") {
      brandsek = "../../assets/images/image-gallery/Final_Logo.png";
    } else if(browser[2].split(".")[0] && browser[2].split(".")[0] == "invinsense") {
      brandsek = '../../assets/images/image-gallery/Invinsense_logo_white.png?v=1'
    }
    return (
      <>
        <div className="page-wrapper page-wrapper_login">
          <div className="section bg-default wf-section">
            <div className="container-fluid p-0">
              <div className="row m-0" style={{ display: "flex", flexWrap: "wrap", marginRight: "-15px", marginLeft: "-15px", alignItems: "center", height: "100vh" }}>
                <div className="col-md-7 p-0">
                  <div className="login-image">
                    <img src={brandsekLoginBanner} alt="brandsek" />
                    <h2 className="login-image-heading">Secure your digital world—because every click matters</h2>
                  </div>
                </div>
                <div className="col-md-5 p-0">
                  <div className="sign-form w-form">
                    <form className="form-auth-small m-t-20">
                      <div className="sign-card-content">
                        <div className="loginContentBox">
                          <img src={logo} className="img-fluid" alt="brandsek" />
                          <h2 className="display-2 text-center mg-bottom-24px keep">Reset Password</h2>
                          <p className="text-center mg-bottom-24px keep">Enter your new password below</p>
                        </div>
                        <div className="mg-bottom-24px keep">
                          <div>
                            <div className="has-feedback position-relative mb-3">
                              <label htmlFor="passwords" className="form-label">New Password</label>
                              <input
                                type={this.state.showPassword ? "text" : "password"}
                                className="input input-form w-input"
                                id="passwords"
                                required="required"
                                placeholder="New Password"
                              />
                              <i
                                style={{
                                  position: "absolute",
                                  top: "55px",
                                  right: "15px",
                                  width: "34px",
                                  textAlign: "center",
                                  height: "34px",
                                  zIndex: "2",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                  color: "#453AD1"
                                }}
                                className={
                                  this.state.showPassword
                                    ? "form-control-feedback fa fa-eye-slash"
                                    : "form-control-feedback fa fa-eye"
                                }
                                onClick={() =>
                                  this.setState({ showPassword: !this.state.showPassword })
                                }
                              ></i>
                            </div>
                            <div className="has-feedback position-relative mb-3">
                              <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
                              <input
                                type={this.state.showPassword ? "text" : "password"}
                                className="input input-form w-input"
                                id="confirmPassword"
                                required="required"
                                placeholder="Confirm Password"
                              />
                            </div>
                          </div>
                        </div>
                        <button
                          type="button"
                          onClick={this.resetPassword}
                          className="loginButton btn-primary width-100 w-button loginsignbutton"
                          style={{ color: "black !important" }}
                          onMouseDown={(e) => e.target.style.color = 'black'}
                        >
                          Reset Password
                        </button>
                      </div>
                      <div className="sign-card-content">
                        <div className="text-center">
                          <div className="text-200 medium color-neutral-100 linkButton">
                            Know your password? <Link to="/login">Login</Link>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps({ auth }) {
  return {
    auth,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      resetPasswordNew,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);

